import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { SidenavComponent } from './sidenav/sidenav.component';
import { CardsComponent } from './cards/cards.component';
import { SliderCardComponent } from './slider-card/slider-card.component';
import { SliderComponent } from './slider/slider.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    CardsComponent,
    SliderComponent,
    SliderCardComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    CardsComponent,
    SliderComponent,
    SliderCardComponent,
  ],
  imports: [CommonModule, IonicModule, RouterModule],
})
export class ComponentsModule {}
